import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import SearchIcon from '../../assets/icons/search.svg'
import { pxToRem } from '../../utils'
import Button from '../Button'

const SearchInput = props => {
  const [focused, setFocused] = useState(false)
  const { placeholder, value, name, label, hasClear, onChange, onClear, onFocus, onBlur, onEnter, ...rest } = props

  const onInputFocus = event => {
    setFocused(true)
    onFocus(event)
  }

  const onInputBlur = event => {
    setFocused(false)
    onBlur(event)
  }

  const onkeypress = event => {
    if (event.key === 'Enter') {
      onEnter()
    }
  }

  return (
    <SearchInputWrapper data-testid="ui-search-input" focused={focused} {...rest}>
      <SearchIcon />
      <TextInput
        id={`input-${label}`}
        aria-label={label}
        placeholder={!value ? placeholder : ''}
        onFocus={onInputFocus}
        onBlur={onInputBlur}
        name={name}
        value={value}
        type="text"
        onChange={onChange}
        onKeyPress={onkeypress}
      />
      {hasClear && value && (
        <ClearButton name="clear" onClick={onClear}>
          Clear
        </ClearButton>
      )}
    </SearchInputWrapper>
  )
}

SearchInput.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  hasClear: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func,
  onEnter: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func
}

SearchInput.defaultProps = {
  label: '',
  value: '',
  placeholder: '',
  name: 'search-input',
  hasClear: true,
  onClear: e => {},
  onEnter: e => {},
  onFocus: e => {},
  onBlur: e => {}
}

const SearchInputWrapper = styled.div`
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  padding: 0 ${pxToRem(12)};
  background: ${props => (props.focused ? props.theme.palette.white : props.theme.palette.grey5)};
  outline: none;
  border: ${props => `1px solid ${props.focused ? props.theme.palette.grey1 : props.theme.palette.grey5}`};
  border-radius: 8px;
  box-shadow: ${props => (props.focused ? '0px 2px 8px rgba(96, 96, 96, 0.2)' : 'none')};
`

const TextInput = styled.input`
  margin-left: ${pxToRem(8)};
  outline: none;
  background: transparent;
  width: 100%;
  border: none;
  ::placeholder {
    font-style: italic;
    font-weight: normal;
    line-height: ${pxToRem(24)};
    color: ${props => props.theme.palette.grey3};
  }
`

const ClearButton = styled(Button)`
  background: transparent;
  padding: 0;
`

export default SearchInput
